import { render, staticRenderFns } from "./gsgly.vue?vue&type=template&id=088ec023&scoped=true&"
import script from "./gsgly.vue?vue&type=script&lang=js&"
export * from "./gsgly.vue?vue&type=script&lang=js&"
import style0 from "./gsgly.vue?vue&type=style&index=0&id=088ec023&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088ec023",
  null
  
)

export default component.exports